// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tabs[data-v-e8e2dc9c] {\n  --nav-link-color: #11291b;\n  --tab-active-color: #ff7058;\n}", ""]);
// Exports
module.exports = exports;
